import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const NextButton = ({
  index,
  questions,
  onClick,
  match,
  dispatch,
  ...props
}) => {
  let languageData = props.language || {}

  return (
    <div className='row'>
      <div className='col px-0'>
        <div className='quiz-row-wrapper submit-next'>
          {(() => {
            const current = index
            const next = current === questions?.length - 1 ? 0 : current + 1
            // console.log('props.index next button index', props)
            return (
              <Link
                replace
                to={`${match?.path}?index=${next}`}
                onClick={() => {
                  console.log('clicked this button')
                  dispatch(onClick(next))
                }}
                className='quiz_next-button'
              >
                <Button color='info' outline>
                  Next
                </Button>
              </Link>
            )
          })()}
        </div>
      </div>
    </div>
  )
}

export default NextButton
